import React, { useState, useEffect } from 'react'

function Countdown({
	renderingStartedAt,
	setRenderingStartedAt,
}: {
	renderingStartedAt: string | undefined
	setRenderingStartedAt: (imgId: string | undefined) => void
}) {
	const [countdown, setCountdown] = useState(0)

	useEffect(() => {
		if (renderingStartedAt) {
			setCountdown(30)
		}
	}, [renderingStartedAt])

	useEffect(() => {
		if (countdown > 0) {
			const timer = setTimeout(() => {
				setCountdown(countdown - 1)
			}, 1000)

			if (countdown == 1) {
				window.location.reload()
				setRenderingStartedAt(undefined)
				setTimeout(() => {
					window.location.reload()
				}, 1000)
			}

			return () => clearTimeout(timer)
		}
	}, [countdown])

	return (
		<div style={{ color: '#cc765a' }}>
			{countdown > 0 ? `${countdown} sec ...` : ''}
		</div>
	)
}

export default Countdown
